import { dataQualityCircle } from 'dls-icons-data'
import { createIcon } from '../common'

const IconQualityCircle = /*#__PURE__*/createIcon(dataQualityCircle)
export default IconQualityCircle
